export default __webpack_public_path__ + "static/media/n9.bc1cca81.svg";